import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import moment from 'moment';
import { ChartType } from 'chart.js';

export class GraphReportModel {
  BarChartData: BarChartData[];
  pieChartLabels: [];
  pieChartData: [];
  DisplayData: DisplayData[];
}
export class DisplayData {
  Title: string;
  Value: any;
  Amount: any;
  Link: string;
}
export class BarChartData {
  data: [];
  label: string;
}

@Component({
    selector: 'app-graph-summary',
    templateUrl: './graph-summary.component.html',
    styleUrls: ['./graph-summary.component.css'],
    standalone: false
})
export class GraphSummaryComponent implements OnInit {
  NsAmount: string;
  NsSent: string;
  NsTableNo: any;
  NsnAmount: string;
  NsnSent: string;
  NsnTableNo: any;
  CsAmount: string;
  CsSent: string;
  CsnAmount: string;
  CsnSent: string;
  url: string;
  PendingData: any;
  NoticeStagesData: any;
  CaseStagesData: any;
  NoticeSeriousnessData: any;
  CaseSeriousnessData: any;
  NoticeExposureData: any;
  CaseExposureData: any;
  UpcomingHearingData: any;
  Displaychart: string;
  HidePie: string;
  HideBar: string;
  NeaHidePie: string;
  NeaHideBar: string;
  CeaHidePie: string;
  CeaHideBar: string;
  UpcomingHidePie: string;
  UpcomingHideBar: string;
  NsHidePie: string;
  NsHideBar: string;
  CsHidePie: string;
  CsHideBar: string;
  NsnHidePie: string;
  NsnHideBar: string;
  CsnHidePie: string;
  CsnHideBar: string;
  NeaHeading: string;
  CeaHeading: string;
  NsHeading: string;
  CsHeading: string;
  NsnHeading: string;
  CsnHeading: string;
  ReportData: any;
  date: string;
  mbarChartLabels: string;
  public PendingpieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public PendingpieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public PendingbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public PendingbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public NoticeExpAmtpieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public NoticeExpAmtpieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public NoticeExpAmtbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public NoticeExpAmtbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public CaseExpAmtpieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public CaseExpAmtpieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public CaseExpAmtbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public CaseExpAmtbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public UpcomingpieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public UpcomingpieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public UpcomingbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public UpcomingbarChartLabels: any; // >=["Abhishek","Abhishek1","Abhishek2","Abhishek3","Abhishek4","Abhishek5","Abhishek6","Abhishek7","Abhishek8","Abhishek9","Abhishek11"];
  public NoticeStagespieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public NoticeStagespieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public NoticeStagesbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public NoticeStagesbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public CaseStagespieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public CaseStagespieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public CaseStagesbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public CaseStagesbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public NoticeSeriousnesspieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public NoticeSeriousnesspieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public NoticeSeriousnessbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public NoticeSeriousnessbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  public CaseSeriousnesspieChartLabels: string[] = ['C', 'S', 'F', 'IE', 'Sa', 'Fi', 'InE', 'Sri', 'Fox', 'Explorer'];
  public CaseSeriousnesspieChartData: number[] = [40, 20, 20, 10, 20, 20, 10, 20, 20, 10, 20, 20, 10];
  public CaseSeriousnessbarChartData: any[] = [
    { data: [55], label: 'Company A' }
  ];
  public CaseSeriousnessbarChartLabels: Array<any> = ["Abhishek", "Abhishek1", "Abhishek2", "Abhishek3", "Abhishek4", "Abhishek5", "Abhishek6", "Abhishek7", "Abhishek8", "Abhishek9", "Abhishek11"];
  ReportName: string;
  IsSent: number;

  public barChartOptions: any = {
    scaleShowVerticalLines: true,
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  public barChartType: ChartType = 'bar';
  public barChartLegend: boolean = true;
  public barChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(105,159,177,0.2)',
      borderColor: 'rgba(105,159,177,1)',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }, {
      backgroundColor: 'rgba(77,20,96,0.3)',
      borderColor: 'rgba(77,20,96,1)',
      pointBackgroundColor: 'rgba(77,20,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)'
    }
  ];
  public pieChartType: ChartType = 'pie';
  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.date = moment().format("DD-MMM-YYYY");
    this.Displaychart = "Bar";
    this.HideBar = "!isHidden";
    this.HidePie = "";
    this.NeaHideBar = "!isHidden";
    this.NeaHidePie = "";
    this.CeaHideBar = "!isHidden";
    this.CeaHidePie = "";
    this.UpcomingHideBar = "";
    this.UpcomingHidePie = "!isHidden";
    this.NsHideBar = "";
    this.CsHidePie = "!isHidden";
    this.CsHideBar = "";
    this.NsHidePie = "!isHidden";
    this.NsnHideBar = "";
    this.CsnHidePie = "!isHidden";
    this.CsnHideBar = "";
    this.NsnHidePie = "!isHidden";
    this.ReportName = 'All';
    this.IsSent = 0;
    this.NeaHeading = '(Received)';
    this.NsHeading = '(Received)';
    this.CsHeading = '(Against Us)';
    this.NsnHeading = '(Received)';
    this.CsnHeading = '(Against Us)';
    this.CeaHeading = '(Against Us)';
    this.NsAmount = "0";
    this.NsSent = "0";
    this.CsAmount = "0";
    this.CsSent = "0";
    this.NsnAmount = "0";
    this.NsnSent = "0";
    this.CsnAmount = "0";
    this.CsnSent = "0";

    this.http.get(this.url + 'GraphReport/Report_Dashboard_Summary?ReportName=' + this.ReportName + '&IsSent=' + this.IsSent)
      .subscribe((data) => {
        this.ReportData = JSON.parse(data.toString());
        let graphReportModel: GraphReportModel[] = JSON.parse(data.toString());
        console.log(data);

        //Pending Dasboard Report
        this.PendingbarChartData = graphReportModel[0].BarChartData;
        this.PendingData = graphReportModel[0].DisplayData;
        this.PendingpieChartLabels = graphReportModel[0].pieChartLabels;
        this.PendingpieChartData = graphReportModel[0].pieChartData;
        this.PendingbarChartLabels = ["Pending Work Detail"]; //graphReportModel[0].pieChartLabels;
        //Notice Exposure Amount Report
        this.NoticeExpAmtbarChartData = graphReportModel[1].BarChartData;
        this.NoticeExposureData = graphReportModel[1].DisplayData;
        this.NoticeExpAmtpieChartLabels = graphReportModel[1].pieChartLabels;
        this.NoticeExpAmtpieChartData = graphReportModel[1].pieChartData;
        this.NoticeExpAmtbarChartLabels = ["Notice Exposure Amount Report "];
        //Case Exposure Amount Report
        this.CaseExpAmtbarChartData = graphReportModel[3].BarChartData;
        this.CaseExposureData = graphReportModel[3].DisplayData;
        this.CaseExpAmtpieChartLabels = graphReportModel[3].pieChartLabels;
        this.CaseExpAmtpieChartData = graphReportModel[3].pieChartData;
        this.CaseExpAmtbarChartLabels = ["Case Exposure Amount Report"];
        //Upcoming Hearing Report
        this.UpcomingbarChartData = graphReportModel[5].BarChartData;
        this.UpcomingHearingData = graphReportModel[5].DisplayData;
        this.UpcomingpieChartLabels = graphReportModel[5].pieChartLabels;
        this.UpcomingpieChartData = graphReportModel[5].pieChartData;
        this.UpcomingbarChartLabels = ["Upcoming Hearing"];
        //Notice Stages Report
        this.NoticeStagesbarChartData = graphReportModel[6].BarChartData;
        this.NoticeStagesData = graphReportModel[6].DisplayData;
        this.NoticeStagespieChartLabels = graphReportModel[6].pieChartLabels;
        this.NoticeStagespieChartData = graphReportModel[6].pieChartData;
        this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
        this.NsTableNo = 6;
        //Case Stages Report
        this.CaseStagesbarChartData = graphReportModel[10].BarChartData;
        this.CaseStagesData = graphReportModel[10].DisplayData;
        this.CaseStagespieChartLabels = graphReportModel[10].pieChartLabels;
        this.CaseStagespieChartData = graphReportModel[10].pieChartData;
        this.CaseStagesbarChartLabels = ["Case Stages Report "];
        //Notice Seriousness Report
        this.NoticeSeriousnessbarChartData = graphReportModel[14].BarChartData;
        this.NoticeSeriousnessData = graphReportModel[14].DisplayData;
        this.NoticeSeriousnesspieChartLabels = graphReportModel[14].pieChartLabels;
        this.NoticeSeriousnesspieChartData = graphReportModel[14].pieChartData;
        this.NsnTableNo = 14;
        this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
        //Case Seriousness Report
        this.CaseSeriousnessbarChartData = graphReportModel[18].BarChartData;
        this.CaseSeriousnessData = graphReportModel[18].DisplayData;
        this.CaseSeriousnesspieChartLabels = graphReportModel[18].pieChartLabels;
        this.CaseSeriousnesspieChartData = graphReportModel[18].pieChartData;
        this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
        this.NeaIsSent('1');
        this.NsIsSent('1');
        this.CeaIsSent('1');
        this.CsIsSent('1');
        this.NsnIsSent('1');
        this.CsnIsSent('1');
      }
      );

  }

  OnSelectPendingChart(PendingChartType) {
    if (PendingChartType == 'Pie') {
      this.HideBar = "!isHidden";
      this.HidePie = "";
    } else if (PendingChartType == 'Bar') {
      this.HideBar = "";
      this.HidePie = "!isHidden";
    }
  }
  OnSelectNeaChart(NeaChartType) {
    if (NeaChartType == 'Pie') {
      this.NeaHideBar = "!isHidden";
      this.NeaHidePie = "";
    } else if (NeaChartType == 'Bar') {
      this.NeaHideBar = "";
      this.NeaHidePie = "!isHidden";
    }
  }

  // NeaIsSent Notice Exposure Amount Report Sent or Recieved
  NeaIsSent(NeaSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (NeaSentType == '1') {
      this.NeaHeading = '(Sent)';
      this.NoticeExpAmtbarChartData = graphReportModel[2].BarChartData;
      this.NoticeExposureData = graphReportModel[2].DisplayData;
      this.NoticeExpAmtpieChartLabels = graphReportModel[2].pieChartLabels;
      this.NoticeExpAmtpieChartData = graphReportModel[2].pieChartData;
      this.NoticeExpAmtbarChartLabels = ["Notice Exposure Amount Report "];
    } else if (NeaSentType == '0') {
      this.NeaHeading = '(Received)';
      this.NoticeExpAmtbarChartData = graphReportModel[1].BarChartData;
      this.NoticeExposureData = graphReportModel[1].DisplayData;
      this.NoticeExpAmtpieChartLabels = graphReportModel[1].pieChartLabels;
      this.NoticeExpAmtpieChartData = graphReportModel[1].pieChartData;
      this.NoticeExpAmtbarChartLabels = ["Notice Exposure Amount Report "];
    }
  }

  OnSelectCeaChart(CeaChartType) {
    if (CeaChartType == 'Pie') {
      this.CeaHideBar = "!isHidden";
      this.CeaHidePie = "";
    } else if (CeaChartType == 'Bar') {
      this.CeaHideBar = "";
      this.CeaHidePie = "!isHidden";
    }
  }
  CeaIsSent(CeaSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (CeaSentType == '1') {
      this.CeaHeading = '(Filed By Us)';
      this.CaseExpAmtbarChartData = graphReportModel[4].BarChartData;
      this.CaseExposureData = graphReportModel[4].DisplayData;
      this.CaseExpAmtpieChartLabels = graphReportModel[4].pieChartLabels;
      this.CaseExpAmtpieChartData = graphReportModel[4].pieChartData;
      this.CaseExpAmtbarChartLabels = ["Case Exposure Amount Report"];
    } else if (CeaSentType == '0') {
      this.CeaHeading = '(Against Us)';
      this.CaseExpAmtbarChartData = graphReportModel[3].BarChartData;
      this.CaseExposureData = graphReportModel[3].DisplayData;
      this.CaseExpAmtpieChartLabels = graphReportModel[3].pieChartLabels;
      this.CaseExpAmtpieChartData = graphReportModel[3].pieChartData;
      this.CaseExpAmtbarChartLabels = ["Case Exposure Amount Report"];
    }
  }
  OnSelectUpcomingChart(UpcomingChartType) {
    if (UpcomingChartType == 'Pie') {
      this.UpcomingHideBar = "!isHidden";
      this.UpcomingHidePie = "";
    } else if (UpcomingChartType == 'Bar') {
      this.UpcomingHideBar = "";
      this.UpcomingHidePie = "!isHidden";
    }
  }

  // NsIsSent Notice Stages Report Sent or Recieved
  NsIsSent(NsSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;

    if (NsSentType == '1' && this.NsAmount == "1") {
      this.NsHeading = '(Sent)';
      this.NsSent = "1";
      this.NoticeStagesbarChartData = graphReportModel[9].BarChartData;
      this.NoticeStagesData = graphReportModel[9].DisplayData;
      this.NoticeStagespieChartLabels = graphReportModel[9].pieChartLabels;
      this.NoticeStagespieChartData = graphReportModel[9].pieChartData;
      this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
    } else if (NsSentType == '0' && this.NsAmount == "0") {
      this.NsHeading = '(Received)';
      this.NsSent = "0";
      this.NoticeStagesbarChartData = graphReportModel[6].BarChartData;
      this.NoticeStagesData = graphReportModel[6].DisplayData;
      this.NoticeStagespieChartLabels = graphReportModel[6].pieChartLabels;
      this.NoticeStagespieChartData = graphReportModel[6].pieChartData;
      this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
    } else if (NsSentType == '1' && this.NsAmount == "0") {
      this.NsHeading = '(Sent)';
      this.NsSent = "1";
      this.NoticeStagesbarChartData = graphReportModel[8].BarChartData;
      this.NoticeStagesData = graphReportModel[8].DisplayData;
      this.NoticeStagespieChartLabels = graphReportModel[8].pieChartLabels;
      this.NoticeStagespieChartData = graphReportModel[8].pieChartData;
      this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
    } else if (NsSentType == '0' && this.NsAmount == "1") {
      this.NsHeading = '(Received)';
      this.NsSent = "0";
      this.NoticeStagesbarChartData = graphReportModel[7].BarChartData;
      this.NoticeStagesData = graphReportModel[7].DisplayData;
      this.NoticeStagespieChartLabels = graphReportModel[7].pieChartLabels;
      this.NoticeStagespieChartData = graphReportModel[7].pieChartData;
      this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
    }
  }
  OnSelectNsChart(NsChartType) {
    if (NsChartType == 'Pie') {
      this.NsHideBar = "!isHidden";
      this.NsHidePie = "";
    } else if (NsChartType == 'Bar') {
      this.NsHideBar = "";
      this.NsHidePie = "!isHidden";
    }
  }
  NsIsAmount(NsIsAmountType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (NsIsAmountType == '1' && this.NsSent == "1") {
      this.NsHeading = '(Sent)';
      this.NsAmount = "1";
      this.NsTableNo = 9;
    } else if (NsIsAmountType == '0' && this.NsSent == "1") {
      this.NsHeading = '(Sent)';
      this.NsAmount = "0";
      this.NsTableNo = 8;
    } else if (NsIsAmountType == '1' && this.NsSent == "0") {
      this.NsHeading = '(Received)';
      this.NsAmount = "1";
      this.NsTableNo = 7;
    } else if (NsIsAmountType == '0' && this.NsSent == "0") {
      this.NsHeading = '(Received)';
      this.NsAmount = "0";
      this.NsTableNo = 7;
    }

    this.NoticeStagesbarChartData = graphReportModel[this.NsTableNo].BarChartData;
    this.NoticeStagesData = graphReportModel[this.NsTableNo].DisplayData;
    this.NoticeStagespieChartLabels = graphReportModel[this.NsTableNo].pieChartLabels;
    this.NoticeStagespieChartData = graphReportModel[this.NsTableNo].pieChartData;
    this.NoticeStagesbarChartLabels = ["Notice Stages Report"];
  }

  // CsIsSent Case Stages Report Filed By Us / Against Us
  CsIsSent(CsSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;

    if (CsSentType == '1' && this.CsAmount == "1") {
      this.CsHeading = '(Filed By Us)';
      this.CsSent = "1";
      this.CaseStagesbarChartData = graphReportModel[13].BarChartData;
      this.CaseStagesData = graphReportModel[13].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[13].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[13].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsSentType == '0' && this.CsAmount == "0") {
      this.CsHeading = '(Against Us)';
      this.CsSent = "0";
      this.CaseStagesbarChartData = graphReportModel[10].BarChartData;
      this.CaseStagesData = graphReportModel[10].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[10].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[10].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsSentType == '1' && this.CsAmount == "0") {
      this.CsHeading = '(Filed By Us)';
      this.CsSent = "1";
      this.CaseStagesbarChartData = graphReportModel[12].BarChartData;
      this.CaseStagesData = graphReportModel[12].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[12].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[12].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsSentType == '0' && this.CsAmount == "1") {
      this.CsHeading = '(Against Us)';
      this.CsSent = "0";
      this.CaseStagesbarChartData = graphReportModel[11].BarChartData;
      this.CaseStagesData = graphReportModel[11].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[11].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[11].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    }
  }
  OnSelectCsChart(CsChartType) {
    if (CsChartType == 'Pie') {
      this.CsHideBar = "!isHidden";
      this.CsHidePie = "";
    } else if (CsChartType == 'Bar') {
      this.CsHideBar = "";
      this.CsHidePie = "!isHidden";
    }
  }
  CsIsAmount(CsIsAmountType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (CsIsAmountType == '1' && this.CsSent == "1") {
      this.CsHeading = '(Filed By Us)';
      this.CsAmount = "1";
      this.CaseStagesbarChartData = graphReportModel[13].BarChartData;
      this.CaseStagesData = graphReportModel[13].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[13].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[13].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsIsAmountType == '0' && this.CsSent == "1") {
      this.CsHeading = '(Filed By Us)';
      this.CsAmount = "0";
      this.CaseStagesbarChartData = graphReportModel[12].BarChartData;
      this.CaseStagesData = graphReportModel[12].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[12].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[12].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsIsAmountType == '1' && this.CsSent == "0") {
      this.CsHeading = '(Against Us)';
      this.CsAmount = "1";
      this.CaseStagesbarChartData = graphReportModel[11].BarChartData;
      this.CaseStagesData = graphReportModel[11].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[11].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[11].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    } else if (CsIsAmountType == '0' && this.CsSent == "0") {
      this.CsHeading = '(Against Us)';
      this.CsAmount = "0";
      this.CaseStagesbarChartData = graphReportModel[10].BarChartData;
      this.CaseStagesData = graphReportModel[10].DisplayData;
      this.CaseStagespieChartLabels = graphReportModel[10].pieChartLabels;
      this.CaseStagespieChartData = graphReportModel[10].pieChartData;
      this.CaseStagesbarChartLabels = ["Case Stages Report "];
    }
  }

  // NsnIsSent Notice Seriousness Report Sent or Recieved
  NsnIsSent(NsnSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;

    if (NsnSentType == '1' && this.NsnAmount == "1") {
      this.NsnHeading = '(Sent)';
      this.NsnSent = "1";
      this.NoticeSeriousnessbarChartData = graphReportModel[17].BarChartData;
      this.NoticeSeriousnessData = graphReportModel[17].DisplayData;
      this.NoticeSeriousnesspieChartLabels = graphReportModel[17].pieChartLabels;
      this.NoticeSeriousnesspieChartData = graphReportModel[17].pieChartData;
      this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
    } else if (NsnSentType == '0' && this.NsnAmount == "0") {
      this.NsnHeading = '(Received)';
      this.NsnSent = "0";
      this.NoticeSeriousnessbarChartData = graphReportModel[14].BarChartData;
      this.NoticeSeriousnessData = graphReportModel[14].DisplayData;
      this.NoticeSeriousnesspieChartLabels = graphReportModel[14].pieChartLabels;
      this.NoticeSeriousnesspieChartData = graphReportModel[14].pieChartData;
      this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
    } else if (NsnSentType == '1' && this.NsnAmount == "0") {
      this.NsnHeading = '(Sent)';
      this.NsnSent = "1";
      this.NoticeSeriousnessbarChartData = graphReportModel[16].BarChartData;
      this.NoticeSeriousnessData = graphReportModel[16].DisplayData;
      this.NoticeSeriousnesspieChartLabels = graphReportModel[16].pieChartLabels;
      this.NoticeSeriousnesspieChartData = graphReportModel[16].pieChartData;
      this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
    } else if (NsnSentType == '0' && this.NsnAmount == "1") {
      this.NsnHeading = '(Received)';
      this.NsnSent = "0";
      this.NoticeSeriousnessbarChartData = graphReportModel[15].BarChartData;
      this.NoticeSeriousnessData = graphReportModel[15].DisplayData;
      this.NoticeSeriousnesspieChartLabels = graphReportModel[15].pieChartLabels;
      this.NoticeSeriousnesspieChartData = graphReportModel[15].pieChartData;
      this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
    }
  }
  OnSelectNsnChart(NsnChartType) {
    if (NsnChartType == 'Pie') {
      this.NsnHideBar = "!isHidden";
      this.NsnHidePie = "";
    } else if (NsnChartType == 'Bar') {
      this.NsnHideBar = "";
      this.NsnHidePie = "!isHidden";
    }
  }
  NsnIsAmount(NsnIsAmountType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (NsnIsAmountType == '1' && this.NsnSent == "1") {
      this.NsnHeading = '(Sent)';
      this.NsnAmount = "1";
      this.NsnTableNo = 17;
    } else if (NsnIsAmountType == '0' && this.NsnSent == "1") {
      this.NsnHeading = '(Sent)';
      this.NsnAmount = "0";
      this.NsnTableNo = 16;
    } else if (NsnIsAmountType == '1' && this.NsnSent == "0") {
      this.NsnHeading = '(Received)';
      this.NsnAmount = "1";
      this.NsnTableNo = 15;
    } else if (NsnIsAmountType == '0' && this.NsnSent == "0") {
      this.NsnHeading = '(Received)';
      this.NsnAmount = "0";
      this.NsnTableNo = 15;
    }

    this.NoticeSeriousnessbarChartData = graphReportModel[this.NsnTableNo].BarChartData;
    this.NoticeSeriousnessData = graphReportModel[this.NsnTableNo].DisplayData;
    this.NoticeSeriousnesspieChartLabels = graphReportModel[this.NsnTableNo].pieChartLabels;
    this.NoticeSeriousnesspieChartData = graphReportModel[this.NsnTableNo].pieChartData;
    this.NoticeSeriousnessbarChartLabels = ["Notice Seriousness Report"];
  }

  // CsnIsSent Case Seriousness Report Filed By Us / Against Us
  CsnIsSent(CsnSentType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;

    if (CsnSentType == '1' && this.CsnAmount == "1") {
      this.CsnHeading = '(Filed By Us)';
      this.CsnSent = "1";
      this.CaseSeriousnessbarChartData = graphReportModel[21].BarChartData;
      this.CaseSeriousnessData = graphReportModel[21].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[21].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[21].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnSentType == '0' && this.CsnAmount == "0") {
      this.CsnHeading = '(Against Us)';
      this.CsnSent = "0";
      this.CaseSeriousnessbarChartData = graphReportModel[18].BarChartData;
      this.CaseSeriousnessData = graphReportModel[18].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[18].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[18].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnSentType == '1' && this.CsnAmount == "0") {
      this.CsnHeading = '(Filed By Us)';
      this.CsnSent = "1";
      this.CaseSeriousnessbarChartData = graphReportModel[20].BarChartData;
      this.CaseSeriousnessData = graphReportModel[20].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[20].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[20].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnSentType == '0' && this.CsnAmount == "1") {
      this.CsnHeading = '(Against Us)';
      this.CsnSent = "0";
      this.CaseSeriousnessbarChartData = graphReportModel[19].BarChartData;
      this.CaseSeriousnessData = graphReportModel[19].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[19].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[19].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    }
  }
  OnSelectCsnChart(CsnChartType) {
    if (CsnChartType == 'Pie') {
      this.CsnHideBar = "!isHidden";
      this.CsnHidePie = "";
    } else if (CsnChartType == 'Bar') {
      this.CsnHideBar = "";
      this.CsnHidePie = "!isHidden";
    }
  }
  CsnIsAmount(CsnIsAmountType) {
    let graphReportModel: GraphReportModel[] = this.ReportData;
    if (CsnIsAmountType == '1' && this.CsnSent == "1") {
      this.CsnHeading = '(Filed By Us)';
      this.CsnAmount = "1";
      this.CaseSeriousnessbarChartData = graphReportModel[21].BarChartData;
      this.CaseSeriousnessData = graphReportModel[21].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[21].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[21].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnIsAmountType == '0' && this.CsnSent == "1") {
      this.CsnHeading = '(Filed By Us)';
      this.CsnAmount = "0";
      this.CaseSeriousnessbarChartData = graphReportModel[20].BarChartData;
      this.CaseSeriousnessData = graphReportModel[20].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[20].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[20].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnIsAmountType == '1' && this.CsnSent == "0") {
      this.CsnHeading = '(Against Us)';
      this.CsnAmount = "1";
      this.CaseSeriousnessbarChartData = graphReportModel[19].BarChartData;
      this.CaseSeriousnessData = graphReportModel[19].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[19].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[19].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    } else if (CsnIsAmountType == '0' && this.CsnSent == "0") {
      this.CsnHeading = '(Against Us)';
      this.CsnAmount = "0";
      this.CaseSeriousnessbarChartData = graphReportModel[18].BarChartData;
      this.CaseSeriousnessData = graphReportModel[18].DisplayData;
      this.CaseSeriousnesspieChartLabels = graphReportModel[18].pieChartLabels;
      this.CaseSeriousnesspieChartData = graphReportModel[18].pieChartData;
      this.CaseSeriousnessbarChartLabels = ["Case Seriousness Report"];
    }
  }

  SameLineUsePrint(ShowHide) {
    document.getElementById('HidePending').style.display = ShowHide;
    document.getElementById('HideNoticeStages').style.display = ShowHide;
    document.getElementById('HideNoticeSeriousness').style.display = ShowHide;
    document.getElementById('HideCaseExposure').style.display = ShowHide;
    document.getElementById('HideCaseStages').style.display = ShowHide;
    document.getElementById('HideCaseSeriousness').style.display = ShowHide;
    document.getElementById('HideNoticeExposure').style.display = ShowHide;
    document.getElementById('HideHearing').style.display = ShowHide;
    document.getElementById('MasterMenu').style.display = ShowHide;
    document.getElementById('MasterMenuDivider').style.display = ShowHide;
    document.getElementById('MasterMenuHeader').style.display = ShowHide;
  }

  PrintDiv(showDiv, HidePrint) {
    this.SameLineUsePrint('none');
    document.getElementById(HidePrint).style.display = "none";
    var printContents = document.getElementById('PrintPage').innerHTML;
    var originalContents = document.body.innerHTML;
    document.getElementById(showDiv).style.display = "";
    window.print();
    //setTimeout(function(){ 
    this.SameLineUsePrint('block');
    document.getElementById(HidePrint).style.display = "block";
    //}, 1000);
  }
}
